/**
 * Created by jv on 15/05/2018.
 */
import CONSTANTS from "Sources/games/carrot-game/config/constants";
import files from "Sources/games/carrot-game/config/assets";

const carrotGameAtlas = require("Images/games/carrot-game/atlas_carrot-game.png");
const carrotGameAtlasJson = require("Data/games/atlas_carrot-game.json");

export default class Loader extends Phaser.Scene
{
  constructor()
  {
    super({
      key: "Loader",
      pack: { files }
    });
  }

  init()
  {
    var gameWidth = this.sys.game.config.width;
    var gameHeight = this.sys.game.config.height;

    this.add.text(gameWidth / 2, gameHeight / 2, "Loading...", { fontFamily: "RabbitOnTheMoon", fontSize: 18, fontWeight: "normal", fill: "#000000" }).setOrigin(0.5);
  }

  preload()
  {
    this.load.atlas(CONSTANTS.ATLAS_KEY, carrotGameAtlas, carrotGameAtlasJson);
    this.loadFonts();
  }

  create()
  {
    this.createAnimations();
    this.scene.start("Menu");
  }

  loadFonts()
  {
    this.preloadFont("RabbitOnTheMoon");
    this.preloadFont("AbadiMTPro-CondExtraBold");
  }

  preloadFont(font)
  {
    var text = this.add.text(0, 0, "text", { fontFamily: font, fontSize: 1, fill: "#FFFFFF" });
    text.visible = false;
  }

  createAnimations()
  {
    // Rabbit run animation
    var runFrameNames = this.anims.generateFrameNames(CONSTANTS.ATLAS_KEY, {
      start: 1, end: 6, zeroPad: 4,
      prefix: "rabbit/run/", suffix: ".png"
    });
    this.anims.create({ key: "rabbit-run", frames: runFrameNames, frameRate: 10, repeat: -1 });

    // Rabbit rocket run animation
    var runFrameNames = this.anims.generateFrameNames(CONSTANTS.ATLAS_KEY, {
      start: 1, end: 6, zeroPad: 4,
      prefix: "rabbit/run/rocket-cake/", suffix: ".png"
    });
    this.anims.create({ key: "rabbit-rocket-run", frames: runFrameNames, frameRate: 10, repeat: -1 });

    // Rabbit idle animation
    this.anims.create({
      key: "rabbit-idle",
      frames: [ { key: CONSTANTS.ATLAS_KEY, frame: "rabbit/run/0006.png" } ],
      frameRate: 20
    });

    // Rabbit jumping animation
    this.anims.create({
      key: "rabbit-jumping",
      frames: [ { key: CONSTANTS.ATLAS_KEY, frame: "rabbit/jump/up.png" } ],
      frameRate: 20
    });

    // Rabbit rocket jumping animation
    this.anims.create({
      key: "rabbit-rocket-jumping",
      frames: [ { key: CONSTANTS.ATLAS_KEY, frame: "rabbit/jump/rocket-cake/up.png" } ],
      frameRate: 20
    });

    // Rabbit falling animation
    this.anims.create({
      key: "rabbit-falling",
      frames: [ { key: CONSTANTS.ATLAS_KEY, frame: "rabbit/jump/down.png" } ],
      frameRate: 20
    });

    // Rabbit rocket falling animation
    this.anims.create({
      key: "rabbit-rocket-falling",
      frames: [ { key: CONSTANTS.ATLAS_KEY, frame: "rabbit/jump/rocket-cake/down.png" } ],
      frameRate: 20
    });
  }
}



// WEBPACK FOOTER //
// ./app/js/games/carrot-game/scenes/loader.js